import { GoogleMap, Marker } from "@react-google-maps/api";
import { useState } from "react";
import { json } from "stream/consumers";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { extractAddressComponents } from "../../utils/extractAddress";

import { useFormData } from "../../context/FormDataContext";
import {
  FieldError,
  useForm,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";

type data = {
  lat: number;
  lng: number;
};

interface MyInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  register: UseFormRegister<any>; // Allowing dynamic forms
  setValue: UseFormSetValue<any>;
  error?: FieldError;
  validationRules?: object; // Pass validation rules dynamically
}

export function LocationDropdown({
  name,
  register,
  error,
  setValue: formSetValue,
  validationRules,
  ...rest
}: MyInputProps) {
  const [lat, setLat] = useState(0);
  const [lng, setLng] = useState(0);
  const { formData } = useFormData();
  const { setFormValue } = useFormData();
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });

  const onHandle = (s: any) => {
    setValue(s.description, false);

    clearSuggestions();

    formSetValue(name, s.description);

    console.log(s);

    const service = new window.google.maps.places.PlacesService(
      document.createElement("div"),
    );

    service.getDetails({ placeId: s.place_id }, (place, status) => {
      if (
        status === window.google.maps.places.PlacesServiceStatus.OK &&
        place &&
        place.geometry &&
        place.geometry.location
      ) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        formSetValue("lat", `${lat}`);
        formSetValue("lng", `${lng}`);

        const extracted = extractAddressComponents(place.address_components);

        setFormValue("city", extracted?.city);
        setFormValue("state", extracted?.state);
      } else {
        console.error("Failed to fetch place details:", status);
      }
    });
  };

  return (
    <div className="relative z-99 ">
      {/* <input {...register("lat")} value={lat} />
      <input {...register("lng")} value={lng} /> */}
      <input
        {...register(name, validationRules)} // Apply dynamic validation rules
        {...rest}
        autoComplete="off"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={!ready}
        className="h-7 w-full border px-1 py-1 text-xs shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
      />
      {status === "OK" && (
        <ul className="absolute bg-white shadow-lg w-full max-h-60 overflow-y-auto">
          {data.map((s) => (
            <li
              key={s.place_id}
              onClick={() => {
                onHandle(s);
                // setValue(s.description, false);
                clearSuggestions();
                //const results = await getGeocode({ address: s.description });
                //const { lat, lng } = await getLatLng(results[0]);
                // onSelect({ description: s.description, lat, lng });
              }}
              className="px-2 py-1 text-xs hover:bg-gray-100 cursor-pointer"
            >
              {s.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
